import React, {useId} from 'react';

export const StrokeGradientText = ({
    text = 'GRADIENT TEXT',
    fontSize = 48,
    fontWeight = 'bold',
    strokeWidth = '3px',
    className = '',
}) => {
    const uuid = useId()

    // Chuyển đổi từ CSS px sang SVG units để hiển thị đúng kích thước
    const svgFontSize = fontSize * 1.33;
    return (
        <div className={`inline-block ${className}`}>
            <svg width="100%" height="100%" viewBox="0 0 1200 150" className="overflow-visible">
                <defs>
                    {/* Định nghĩa gradient cho stroke */}
                    <linearGradient id={`${uuid}-strokeGradient`} x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="18.72%" stopColor="#DABA03" />
                        <stop offset="37.08%" stopColor="#FFF04D" />
                        <stop offset="43.79%" stopColor="#FFFDBD" />
                        <stop offset="57.39%" stopColor="#CEAF00" />
                        <stop offset="66.64%" stopColor="#FFFDBD" />
                        <stop offset="77.01%" stopColor="#FFE659" />
                    </linearGradient>

                    {/* Định nghĩa gradient cho fill */}
                    <linearGradient id={`${uuid}-fillGradient`} x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="1.06%" stopColor="#E6FFFD" />
                        <stop offset="95.93%" stopColor="#F6E989" />
                    </linearGradient>
                </defs>

                <text
                    x="50%"
                    y="60%"
                    textAnchor="middle"
                    dominantBaseline="middle"
                    fontSize={svgFontSize}
                    fontWeight={fontWeight}
                    fill={`url(#${uuid}-strokeGradient)`}
                    stroke={`url(#${uuid}-fillGradient)`}
                    strokeWidth={strokeWidth}
                    strokeLinejoin="round"
                    strokeLinecap="round">
                    {text}
                </text>
            </svg>
        </div>
    );
};
